import React from 'react';
import { motion } from 'framer-motion';
export function PersonalSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto bg-brand-card rounded-[3rem] shadow-sm my-12 border border-brand-accent/10" data-id="element-125">
      <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-126">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="relative rounded-[2rem] overflow-hidden shadow-xl aspect-[4/5] lg:aspect-square" data-id="element-127">
          <img src="https://cdn.magicpatterns.com/uploads/eyXudEboE1GYu3sqhKBB9M/ME_PRESENTO.jpg" alt="Carolina, creadora de Arte en Tricotín" className="w-full h-full object-cover" data-id="element-128" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-129">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl text-brand-text mb-2" data-id="element-130">
            Hola, soy Carolina
          </h2>

          <p className="text-xl text-brand-deep-green font-serif italic mb-8" data-id="element-131">
            Mamá, emprendedora y creadora de Arte en Tricotín
          </p>

          <div className="space-y-6 text-brand-text/80 leading-relaxed text-lg font-sans mb-10" data-id="element-132">
            <p data-id="element-133">Soy mamá y emprendedora de Zona Sur de Buenos Aires.</p>
            <p data-id="element-134">
              Descubrí el arte en tricotín buscando una forma linda y especial
              de crear detalles para cumpleaños, eventos y momentos importantes
              de mis hijos.
            </p>
            
            <p data-id="element-135">
              Con el tiempo, empecé a crear cada vez más, a disfrutar todo el
              proceso y a darme cuenta de que esto también podía transformarse
              en una forma real de generar ingresos extra desde casa, sin dejar
              de estar presente para mi familia.
            </p>
            <p data-id="element-136">
              Así nació este proyecto: con la idea de acompañar a otras mujeres
              que, como yo, quieren aprender algo lindo, creativo y con el
              potencial de convertirse en un pequeño emprendimiento.
            </p>
          </div>

          <div className="bg-brand-alt-bg/50 p-6 rounded-2xl border-l-4 border-brand-cta" data-id="element-137">
            <p className="text-xl text-brand-text font-serif italic leading-snug" data-id="element-138">
              "A veces, un pequeño pasatiempo puede convertirse en algo que
              cambia tu vida."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}